module.exports = __webpack_public_path__ + "img/undraw_microphone.6547551a.svg";